import { ShopifyContext } from '../components/ShopifyProvider'
import { useContext } from 'react'

const useShopify = () => {
  return useContext(ShopifyContext)
}

export { useShopify }
